import { fetchJsonData } from '../util/fetchutils';
import { setCookie, getCookie } from '../components/cookie';

export const initGlobalE = () => {
  if (!window.GlobalE) {
    return setTimeout(initGlobalE, 50);
  }

  // eslint-disable-next-line no-undef, consistent-return
  GlobalE.OnShippingSwitcherClosed((event) => {
    if (event
        && event.button === 'save'
        && (event.country !== window.geScriptLoaderData.country
        || event.currency !== window.geScriptLoaderData.currency)) {
      setCookie('GlobalE_Country_Selector', {
        isSiteChanged: true,
        siteId: window.geScriptLoaderData.siteId,
      });
    } else {
      return false;
    }
  });

  const geCookie = getCookie('GlobalE_Country_Selector');

  if (geCookie) {
    if (geCookie.siteId && geCookie.siteId !== window.geScriptLoaderData.siteId) {
      setCookie('GlobalE_Country_Selector', {
        isSiteChanged: false,
        siteId: window.geScriptLoaderData.siteId,
      });
      if (geCookie.isSiteChanged) return true;
    } else {
      return true;
    }
  }

  // eslint-disable-next-line no-undef
  GlobalE.OnShippingSwitcherClosed((event) => {
    if (event && event.button === 'cancel') {
      let { getSiteRedirectUrl } = window.geScriptLoaderData;
      getSiteRedirectUrl += `?countryCode=${encodeURIComponent(window.siteData.defaultCountry)}`;
      getSiteRedirectUrl += `&currencyCode=${encodeURIComponent(window.siteData.defaultCurrency)}`;

      const requestDataEl = document.querySelector('[data-action][data-querystring]');
      if (requestDataEl) {
        getSiteRedirectUrl += `&action=${encodeURIComponent(requestDataEl.dataset.action)}`;
        getSiteRedirectUrl += `&querystring=${encodeURIComponent(requestDataEl.dataset.querystring)}`;
      }

      fetchJsonData(getSiteRedirectUrl, 'GET')
        .then((response) => {
          let responseObj = response;
          try {
            responseObj = JSON.parse(response);
          } catch (error) {
            console.warn('GlobalE: Unable to parse response JSON'); // eslint-disable-line no-console
            return;
          }

          if (responseObj.redirectUrl) {
            setCookie('GlobalE_Country_Selector', {
              ...(geCookie || {}),
              siteId: window.geScriptLoaderData.siteId,
            });
            window.location.href = responseObj.redirectUrl;
          }
        }).catch((e) => {
          console.warn(e); // eslint-disable-line no-console
        });
    }
  });

  return true;
};

export default () => {
  if (window.siteData && window.siteData.isGlobaleEnabled === 'true'
      && window.siteData.defaultCountry && window.siteData.defaultCurrency
      && (/complete|interactive|loaded/.test(document.readyState))) {
    initGlobalE();
  }
};
